export default __webpack_public_path__ + "static/media/pakrap-11.44751155.mp3";